import rendered from '@mailobj-browser/front/js/tree/rendered.js'
import { scrollToEndY } from '#components/generics/js/scroll/scrollToEnd.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { elements } from '../../../styles.js'

export default container => {
  queueMicrotask(async () => {
    const { ownerDocument } = container
    const { body } = ownerDocument

    await rendered(container, body)

    const main = closest(`.${elements.send_main}`, container)

    if (main) {
      scrollToEndY(main)
    }
  })
}